/**
 * Append query params to a URL
 * @param url original URL
 * @param name query param name
 * @param value query param value
 * @returns URL with appended query params
 */
export const appendQueryParam = (url: string, name: string, value: string) => {
  const urlObject = new URL(url);
  urlObject.searchParams.append(name, value);
  return urlObject.toString();
};

export const isMetaOsHelper = () => {
  const href = location.href;
  const convertedString = href.toLowerCase();

  if (convertedString.indexOf("metaos") === -1) {
    return false;
  }

  return true;
};
